import { RouteType } from "../@types/RouteType";
import {
    LeadsRoutes,
    DashboardRoutes,
    FinancialRoutes,
    GeneralRoutes,
    OrderRoutes,
    RegistrationRoutes,
    ResourcesRoutes,
    TechSupportRoutes,
    WarrantyClaimRoutes
} from "./MainRoutes";


const InternationalDealerAdminRoutes: RouteType[] = [
    ...DashboardRoutes,
    ...OrderRoutes,
    ...RegistrationRoutes,
    ...WarrantyClaimRoutes,
    ...TechSupportRoutes,
    ...FinancialRoutes,
    ...LeadsRoutes,
    ...ResourcesRoutes,
    ...GeneralRoutes
]

export default InternationalDealerAdminRoutes;